<template>
    <div class="disqualified-alert" :class="{[type]: true}">
        <div class="disqualified-content" @click="setShowDisqualifiedTooltip(true)">
            <div class="disqualified-label" v-if="type === 'banner'">
                Disqualified
            </div>
            <span class="tooltip-icon-wrapper">
                <fa-icon icon="exclamation-circle" class="tooltip-icon" />
            </span>
        </div>
        <div class="disqualified-tooltip" v-if="showDisqualifiedTooltip">
            <p class="tooltip-title">
                <strong>Disqualified Account</strong>
            </p>
            <p>
                This account has been disqualified.
            </p>
            <p>
                <strong class="alert-text">Please be cautious when playing against this player.</strong>
            </p>
            <div>
                Accounts may be disqualified for the following reasons:
               <ul class="list">
					<li class="list-item">
                        Cheating -  gaining an unfair advantage by exploiting the game or any bugs,
						 using unauthorized tools or software, using an AI bot to play,
						 or otherwise manipulating gameplay.
                    </li>
                    <li class="list-item">
                        Win trading -  playing games against
                            yourself with a secondary account in order
                            to gain skill rating.
                    </li>
                    <li class="list-item">
                        Fluxxing - systematically creating rooms and changing the settings in the last second.
                    </li>
                    <li class="list-item">
                        Toxic behaviour - using offensive and/or abusive language in the chat.
                    </li>
                    <li class="list-item">
                        Unsportsmanlike behaviour - systematically waiting until the timer nearly runs out each turn, etc.
                    </li>
               </ul>
            </div>
			<br/>
            <p>
                <strong>Disqualified accounts will not appear on the leaderboard.</strong>
            </p>
            <span @click="setShowDisqualifiedTooltip(false)">
                <fa-icon
                    class="close-tooltip-btn"
                    icon="times"
                />
            </span>
        </div>
        <div class="overlay" v-if="showDisqualifiedTooltip" @click="setShowDisqualifiedTooltip(false)"></div>
    </div>
</template>
<script>
export default {
    name: 'DisqualifiedAlert',
    props: ['type'],
    data() {
        return {
            showDisqualifiedTooltip: false,
        };
    },
    methods: {
        setShowDisqualifiedTooltip(value) {
            this.showDisqualifiedTooltip = value;
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .disqualified-alert {
        color: $dark-brown;
        cursor: pointer;
        display: inline-block;
        position: relative;
        text-align: center;
        margin: 0 auto;

        &.banner {
            display: block;

            .disqualified-content {
                background: white;
                border: 2px solid $lancer;
                border-radius: 5px;
                display: inline-flex;
                font-size: 1.2em;
                padding: 10px;

                .tooltip-icon {
                    margin-bottom: 1px;
                    margin-left: 5px;
                    font-size: 1rem;
                }
            }
        }

        .list {
            list-style-type: disc;
            padding-left: 13px;

            .list-item {
                margin-top: 10px;
            }
        }

        .alert-text {
            color: $lancer;
            text-decoration: underline;
        }

        .disqualified-content {
            display: inline-block;
            position: relative;
            color: $lancer;

            .tooltip-icon {
                font-size: .9rem;
            }
        }

        .disqualified-tooltip {
            background: white;
            box-shadow: -1px 1px 2px 2px $light-sage-brown;
            cursor: default;
            display: block;
            font-size: .8rem;
            padding: 20px;
            position: fixed;
            left: 50%;
            text-align: left;
            top: 50%;
            width: 250px;
            transform: translate(-50%, -50%);
            z-index: 152;

            p:last-of-type {
                margin-bottom: 0;
            }

            .tooltip-title {
                font-size: .9rem;
                text-align: center;
            }

            .close-tooltip-btn {
                cursor: pointer;
                position: absolute;
                right: 15px;
                top: 15px;
            }
        }
    }

    .overlay {
        background: transparent;
    }
</style>
